
import { useDatabase } from '@/context/DatabaseContext';

const ConnectionWarning = () => {
  const { isConnected } = useDatabase();
  
  if (isConnected) {
    // Don't show any message when connected
    return null;
  }
  
  // Only show warning when not connected
  return (
    <div className="border-yellow-400 bg-yellow-50 shadow-md mb-8 p-6 rounded-lg">
      <div className="flex items-start gap-4">
        <div>
          <h3 className="font-semibold text-lg mb-2">Database Connection Required</h3>
          <p className="text-gray-700 mb-4">
            This application needs to connect to Supabase to store your assessment data and generate reports. 
            Without a database connection, some features will be limited.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConnectionWarning;
